<template>
   <div>
      <ddoSelect :callbacks="callbacks" ref="mySelect" :options="options">
         <template v-slot:selection="data">
            <v-chip
               v-bind="data.attrs"
               :input-value="data.selected"
            >
               <span v-text="data.item.vla_id+' ('+data.item.vla_name+')'"></span>
            </v-chip>
         </template>

         <template v-slot:item="data">
            <v-list-item-content>
               <v-list-item-title v-html="data.item.vla_id"></v-list-item-title>
               <v-list-item-subtitle v-html="data.item.vla_name"></v-list-item-subtitle>
            </v-list-item-content>
         </template>
      </ddoSelect>
    </div> 
</template>

<script>
import ddoSelect from '@/components/ddoSelect.vue';

export default {
   name: 'ddoSelectVlan',
   mixins: [ddoSelect],
   components: {
      ddoSelect
   },
}
</script>